import { create } from 'zustand';

export interface DonchianMarker {
  markerType: 'long' | 'short';
  symbol: string;
  timestamp: number;
  close: number;
  upper20: number;
  lower20: number;
  mid55: number;
  volumeRatio: number;
  trendAligned: boolean;
}

interface DonchianState {
  markers: DonchianMarker[];
  addMarker: (m: DonchianMarker) => void;
  setMarkers: (m: DonchianMarker[]) => void;
  clearMarkers: () => void;
}

export const useDonchianStore = create<DonchianState>((set) => ({
  markers: [],
  addMarker: (m) =>
    set((state) => ({
      markers: state.markers.some(
        (x) => x.symbol === m.symbol && x.timestamp === m.timestamp
      )
        ? state.markers
        : [...state.markers, m].sort((a, b) => a.timestamp - b.timestamp),
    })),
  setMarkers: (markers) =>
    set({ markers: [...markers].sort((a, b) => a.timestamp - b.timestamp) }),
  clearMarkers: () => set({ markers: [] }),
}));
